import { render, staticRenderFns } from "./GroupViewAvatarCard.vue?vue&type=template&id=7d4fb194"
import script from "./GroupViewAvatarCard.vue?vue&type=script&lang=js"
export * from "./GroupViewAvatarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports